export const TOP_CHEF_PP_FORM_ID = '057c8049-7339-41e7-9341-8549b6198110';
export const TOP_CHEF_PP_FORM_URL = 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms';
export const NBC_PRIVACY = 'NBC Privacy policy'
export const NBC_PRIVACY_LINK = 'https://www.nbcuniversalprivacy.com/privacy'
export const NEW_TAB = 'opens in a new tab'
export const SUCCESS_MESSAGE = 'Thank you for entering our sweepstakes!'
export const TOP_CHEF_SWEEPS_RULE = 'Sweepstakes Terms and Conditions'
export const TOP_CHEF_SWEEPS_RULE_LINK = '/top-chef-sweepstakes-rules/'
export const FORM_SECTION_THEME = "equity-signup-form"